import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  OrganizationUsageStats = 'OrganizationUsageStats',
}

export const useGetOrganizationUsageStatsQuery = (
  periodStart?: string,
  periodEnd?: string,
) => {
  const { getOrganizationUsageStats } = useServicesContext();

  return useQuery({
    queryKey: [CacheKey.OrganizationUsageStats, periodStart, periodEnd],
    queryFn: () => getOrganizationUsageStats(periodStart, periodEnd),
    refetchInterval: 60000,
  });
};
